<template>
  <div id="scoreCards" >
    <div id="statcards" v-if="datum">
      <div class="rowtitle">All times</div>
      <div class="row">
        <div class="su-box col">
          <div>
            <div class="def col-md-12">
              Number of Reviews <i class="bi bi-receipt"></i>
            </div>
            <div class="val col-md-12">{{ datum.desc.number_of_reviews }}</div>

            <!--Never put : to thisdef-->
            <AverageComparison
              :thisval="datum.desc.number_of_reviews"
              thisdef="number_of_reviews"
              :thisgroup="datum.desc.group"
            />
          </div>
        </div>

        <div class="su-box col">
          <div>
            <div class="def col-md-12">
              Number of Sentences <i class="bi bi-receipt"></i>
            </div>
            <div class="val col-md-12">{{ datum.desc.count_of_sentences }}</div>
            <AverageComparison
              :thisval="datum.desc.count_of_sentences"
              thisdef="count_of_sentences"
              :thisgroup="datum.desc.group"
            />
          </div>
        </div>

        <div class="su-box col">
          <div>
            <div class="def col-md-12">
              <!-- Company sentiment score is new nomenclature old name and code name is average sentiment score -->
              Company Sentiment Score <i class="bi bi-thermometer-half"></i>
            </div>
            <div class="val col-md-12"> 
              {{ (datum.desc.average_sentiment_score * 100).toFixed() }}%
            </div>
            <AverageComparison
              :thisval="datum.desc.average_sentiment_score"
              thisdef="average_sentiment_score"
              :thisgroup="datum.desc.group"
            />
          </div>
        </div>

        <div class="su-box col">
          <div>
            <div class="def col-md-12">
              <!-- Old name is unanswered reviews and new name is answered reviews -->

              % of Answered Reviews <i class="bi bi-unlock"></i>
            </div>
            <div class="val col-md-12">
              {{ datum.desc.ratio_of_unanswered_questions }}%
            </div>
            <AverageComparison
              :thisval="datum.desc.ratio_of_unanswered_questions"
              thisdef="ratio_of_unanswered_questions"
              :thisgroup="datum.desc.group"
            />
          </div>
        </div>

        <div class="su-box col">
          <div>
            <div class="def col-md-12">
              <!-- Company response time  is new nomenclature old name and code name is average response time -->
              Company Response Time <i class="bi bi-smartwatch"></i>
            </div>
            <div class="val col-md-12">
              {{ datum.desc.average_response_time }}
            </div>
            <AverageComparison
              :thisval="datum.desc.average_response_time"
              thisdef="average_response_time"
              :thisgroup="datum.desc.group"
            />
          </div>
        </div>
      </div>
      ({{ datum.desc.group }})
    </div>
  </div>
</template>

<script>
import AverageComparison from '@/components/AverageComparison.vue';
export default {
  name: "ScoreCards",
  props: ["datum"],
  components: {
    AverageComparison
  },
};
</script>

<style>

#statcards > .rowtitle {
  color: white;
}
#statcards {
  margin: auto;
  padding: 10px;
  /* background-color: #da074d; */
  color: rgb(183, 158, 158);
}
.su-box {
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px, rgba(0, 0, 0, 0.23) 0px 6px 6px;
  margin: 10px;
  height: 120px;
  align-items: center;
  display: flex;
  background-color: #e8e0e4;
  color: black;
}
.su-box .def {
  font-size: 0.8em;
  font-weight: bold;
  text-align: center;
}
.su-box .benchmark {
  font-size: 0.8em;
  font-weight: bold;
  text-align: center;
  color: #061d2c;
}
.su-box .val {
  font-size: 2.2em;
  font-weight: bold;
  color: #15020c;
  text-align: center;
}


.su-box b {
  color: orange;
}

.rowtitle {
  color: gray;
  font-weight: bold;
}
.rowdesc {
  color: #061d2c;
  font-size: small;
  padding-bottom: 1em;
  margin-bottom: 5px;
}


</style>